import type { ComponentProps } from 'react';
import React from 'react';
import styled from '@emotion/styled';
import type { Customer, EntryPoint, Nullable } from 'corgi-types';
import type { BackgroundColorProps } from 'styled-system';
import { backgroundColor, space } from 'styled-system';

import type { FlexGrowProps } from 'common/theme/system-utilities';
import { flexGrow, listStyle } from 'common/theme/system-utilities';
import BottomNavigationLink from './BottomNavigationLink';
import { useNavigationItems } from './hooks/useNavigationItems';
import { NavigationGroup, navigationGroupStyles } from './NavigationList';
import { NavigationItem } from './NavigationListItem';

interface BottomNavigationSectionProps {
  customer: Nullable<Customer>;
  uspEntryPoints: EntryPoint[];
}

const UnstyledNavigationGroup = styled(NavigationGroup)<BackgroundColorProps & FlexGrowProps>`
  ${listStyle};
  ${space};
  ${backgroundColor};
  ${flexGrow};
`;

const StyledNavigationGroup = (props: ComponentProps<typeof UnstyledNavigationGroup>) => (
  <UnstyledNavigationGroup
    {...navigationGroupStyles}
    backgroundColor="sys.neutral.background.strong"
    py="sp_16"
    px={[null, null, 'sp_32', 'sp_48']}
    flexGrow={1}
    mb="sp_0"
    {...props}
  />
);

const BottomNavigationSection = (props: BottomNavigationSectionProps) => {
  const navigation = useNavigationItems(props);

  return (
    <StyledNavigationGroup>
      {navigation.map((item, index) => (
        <NavigationItem key={index}>
          <BottomNavigationLink {...item} itemIndex={index} itemsCount={navigation.length} />
        </NavigationItem>
      ))}
    </StyledNavigationGroup>
  );
};

export default React.memo(BottomNavigationSection);
